import { render } from "./ReportHistoryVideoAlert.vue?vue&type=template&id=2625a082"
import script from "./ReportHistoryVideoAlert.vue?vue&type=script&lang=js"
export * from "./ReportHistoryVideoAlert.vue?vue&type=script&lang=js"
script.render = render

export default script